<div class="py-2.5 px-7">
  <app-section-header
    [title]="isNew ? 'Admin - Add Topic' : 'Admin - Edit Topic'"
    [isBackBtnShown]="true"
    [preserveQueryParam]="true"
  >
    <div class="flex justify-end flex-1">
      <button
        mat-stroked-button
        color="primary"
        class="ml-3"
        (click)="cancel()"
        [disabled]="isSaving"
      >
        Cancel
      </button>
      <button
        mat-flat-button
        color="primary"
        class="ml-3"
        (click)="save()"
        [disabled]="isSaving || form?.invalid || !hasChanges()"
      >
        <span *ngIf="!isSaving">Save</span>
        <span *ngIf="isSaving">Saving</span>
      </button>
    </div>
  </app-section-header>

  <form *ngIf="form" [formGroup]="form" class="pt-6">
    <mat-tab-group
      dynamicHeight
      mat-stretch-tabs="false"
      class="max-w-3xl font-montserrat topic-tabs"
    >
      <mat-tab label="Details">
        <div
          class="mt-4 bg-white border rounded-md max-w-3xl border-project-200"
        >
          <div class="px-6 py-5 border-b border-project-200">
            <label
              for="topic-name"
              class="block mb-2 text-base font-normal font-montserrat"
            >
              Name <span class="text-project-1600">*</span>
            </label>
            <mat-form-field
              appearance="outline"
              [floatLabel]="'never'"
              class="w-full author_search-box edit_author-box"
            >
              <input
                id="topic-name"
                type="text"
                matInput
                formControlName="name"
                maxlength="250"
                placeholder="Enter a topic name"
              />
            </mat-form-field>
            <p class="mt-1 text-xs font-montserrat text-project-2400">
              The internal name used to identify this topic.
            </p>
          </div>

          <div class="px-6 py-5">
            <label class="block mb-2 text-base font-normal font-montserrat">
              Parent topic
            </label>
            <mat-form-field
              appearance="outline"
              [floatLabel]="'never'"
              class="w-full author_search-box edit_author-box"
            >
              <mat-select formControlName="parentId">
                <mat-option [value]="null">None (top-level topic)</mat-option>
                <mat-option
                  *ngFor="let topic of parentOptions"
                  [value]="topic.id"
                >
                  {{ topic.displayName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <p class="mt-1 text-xs font-montserrat text-project-2400">
              Nest this topic beneath a parent, or leave as a top-level topic.
            </p>
          </div>
        </div>
      </mat-tab>

      <mat-tab label="Published sites">
        <div
          class="px-6 py-5 mt-4 bg-white border rounded-md max-w-3xl border-project-200"
        >
          <p class="mb-3 text-xs font-montserrat text-project-2400">
            Select the sites this topic should be published to.
          </p>
          <div
            class="flex flex-col border rounded-md divide-y border-project-200 divide-project-200"
          >
            <mat-checkbox
              *ngFor="let target of deliveryTargets"
              class="px-4 py-2.5 font-montserrat"
              color="primary"
              [checked]="isChannelSelected(target.code)"
              (change)="toggleChannel(target.code, $event.checked)"
            >
              {{ target.friendlyName }}
            </mat-checkbox>
            <p
              *ngIf="!deliveryTargets.length"
              class="px-4 py-3 text-sm font-montserrat text-project-2400"
            >
              No published sites available.
            </p>
          </div>
        </div>
      </mat-tab>

      <mat-tab label="Translations">
        <div
          class="px-6 py-5 mt-4 bg-white border rounded-md max-w-3xl border-project-200"
        >
          <div class="flex items-center justify-between mb-1">
            <p class="text-xs font-montserrat text-project-2400">
              Provide a translated display name for each supported language.
            </p>
            <button
              type="button"
              mat-stroked-button
              color="primary"
              (click)="addTranslation()"
            >
              Add translation
            </button>
          </div>

          <div formArrayName="translations" class="flex flex-col gap-3 mt-3">
            <div
              *ngFor="let translation of translations.controls; let i = index"
              [formGroupName]="i"
              class="flex items-start gap-3"
            >
              <mat-form-field
                appearance="outline"
                [floatLabel]="'never'"
                class="w-56 author_search-box edit_author-box"
              >
                <mat-select formControlName="language" placeholder="Language">
                  <mat-option
                    *ngFor="
                      let language of languageOptions(
                        translation.get('language')?.value
                      );
                      trackBy: trackByLanguageCode
                    "
                    [value]="language.code"
                    [disabled]="isLanguageTaken(language.code, i)"
                  >
                    {{ language.friendlyName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field
                appearance="outline"
                [floatLabel]="'never'"
                class="flex-1 author_search-box edit_author-box"
              >
                <input
                  type="text"
                  matInput
                  formControlName="displayName"
                  maxlength="250"
                  placeholder="Translated display name"
                />
              </mat-form-field>
              <button
                type="button"
                title="Remove translation"
                class="px-2 py-3 hover:text-project-300"
                (click)="removeTranslation(i)"
              >
                <mat-icon inline>delete</mat-icon>
              </button>
            </div>
            <p
              *ngIf="!translations.controls.length"
              class="text-sm font-montserrat text-project-2400"
            >
              No translations yet. Use “Add translation” to add one.
            </p>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </form>
</div>
